import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  cardSimple: string =
    `<div class="card govco-card">
  <div class="card-body">
    <p class="card-text">Un ejemplo de un card simple.</p>
  </div>
</div>`;

  cardSeccion3: string = `<div class="card govco-card">
  <div class="card-header govco-card-header">
    <span class="govco-icon govco-icon-question-cn"> </span>
    ¿Tienes dudas?
  </div>
  <div class="card-body">
    <p class="card-text">Este card es un ejemplo con 3 secciones header, body y footer.</p>
  </div>
  <div class="card-footer govco-card-footer govco-center">
    <a class="btn-low-mix-govco align-column-govco">
      <span class="btn-mix-govco__title">Ver más detalles</span>
      <span class="btn-mix-govco__icon govco-icon govco-icon-simpled-arrow"></span>
    </a>
  </div>
</div>`

  cardImage: string = `
      <div class="card govco-card ">
        <img src="..." class="card-img govco-card-image govco-card-image-top" alt="..." />
        <div class="card-body">
          <p>Esta card contiene una imagen y una breve descripción </p>
        </div>
      </div>`

  cardImageLeft: string = `
<div class="card govco-card">
  <div class="row">
    <div class="col-sm-6 col-md-6 col-lg-6">
      <img class="card-img govco-card-image govco-card-image-left" src="..." alt="..." />
    </div>
    <div class="col-sm-6 col-md-6 col-lg-6">
      <div class="card-header govco-card-header">
        <a>¿Sabes qué son los datos abiertos y cómo usarlos?</a>
      </div>
      <div class="card-body">
        <p>La información que producen las entidades públicas de su
          trabajo, todo a tu alcance</p>
      </div>
    </div>
  </div>
</div>`
  highlighted: boolean = false;
  constructor(private highlightService: HighlightService) {
    this.infoComponent = {
      titulo: "Card",
    }

  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }
}



